export const FIELD_DATA_ATTR = 'data-bb-field';

export const FIELD_EDITABLE_ATTR = 'data-editable';

export const FIELD_ERROR_DATA_ATTR = 'data-bb-error';

export enum FieldBBType {
	text = 'text',
	email = 'email',
	tel = 'tel',
	date = 'date',
}

export enum FieldBBErrorType {
	required = 'required',
	email = 'email',
	tel = 'tel',
	fullName = 'fullName',
}

export enum FieldEditMode {
	placeholder = 'placeholder',
	value = 'value',
}
